<template>
  <div class="foot-qr-container">
    <div class="foot-qr-title-div">
      <img class="foot-qr-title-img" src="@/assets/yinghui_logo.png">
      <span class="font-qr-title margin-left-10">荧辉科技</span>
    </div>
    <span class="font-qr-text margin-top-15">企业信用不良记录维护，包括行政处罚、司法诉讼、裁判文书、开庭公告、互联网第三方信用平台记录、被执行人、失信被执行人、不良行为及黑名单等。联系我们为您提供免费技术咨询，帮您解决企业信用问题。</span>
    <span class="font-qr-code-text margin-top-20">扫码沟通</span>
    <div class="foot-qr-item-img_bg margin-top-10" @click="onQRCodeClick()">
      <div class="foot-qr-item-img_second_bg">
        <img class="font-qr-code" src="@/assets/qrcode/img_qr_code.jpg">
      </div>
    </div>

  </div>
</template>

<script lang="ts" setup>
import {isShowQrCodeDialog} from "@/views/data/CommonData";

const onQRCodeClick = () => {
  isShowQrCodeDialog.value = true
}
</script>

<style scoped>
.foot-qr-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 20px;
}

.foot-qr-title-div {
  display: flex;
  align-items: center;
}

.foot-qr-title-img {
  width: 20px;
  height: auto;
}

.font-qr-title {
  font-size: 16px;
  font-weight: bold;
  color: #f9fcfc;
}

.font-qr-text {
  font-size: 13px;
  color: #f9fcfc;
  width: 100%;
  line-height: 25px;
  word-wrap: break-word;
}

.font-qr-code-text {
  font-size: 13px;
  color: #b1b1b1;
  width: 100%;
  word-wrap: break-word;
}

.font-qr-code {
  width: 80px;
  height: 80px;
  border-radius: 0px;
}

.foot-qr-item-img_bg {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  /*border: 1px solid #4e5c71;*/
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #383a5b;
}

.foot-qr-item-img_second_bg {
  width: 90px;
  height: 90px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fcfc;
}
</style>
